import React from "react";


const GuestContainer = (props)=>{
    return (
        <div className="login-area">
            {props.children}
        </div>
    )
}

export default GuestContainer;